
import {
  Component, Prop, Vue, Watch
} from 'vue-property-decorator';

const MutationObserver = window.MutationObserver;

@Component
export default class PaymentSettingsCard extends Vue {
  @Prop({ type: String, default: 'mdi-bank' }) readonly icon!: string;

  @Prop(Boolean) readonly expanded!: boolean;

  @Prop(Boolean) readonly inPlace!: boolean;

  $refs!: { content: HTMLElement };

  observer: MutationObserver | null = null;

  contentHeight = 0;

  localExpanded = false;

  get expandable() {
    return !!this.$scopedSlots.content;
  }

  get maxHeight() {
    return this.expandable && this.localExpanded ? `${this.contentHeight}px` : 0;
  }

  get showBorder() {
    return !this.inPlace || this.localExpanded;
  }

  async mounted() {
    const slotElement = this.$refs.content;
    const updateHeight = () => {
      this.contentHeight = slotElement.getBoundingClientRect().height;
    };

    this.observer = new MutationObserver(() => updateHeight());
    this.observer.observe(slotElement, { attributes: true, childList: true, subtree: true });

    this.onPropExpanded(this.expanded);
    await this.$nextTick();
    updateHeight();
  }

  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  action() {
    if (this.expandable) {
      this.localExpanded = !this.localExpanded;
      this.$emit('update:expanded', this.localExpanded);
    }
    this.$emit('click');
  }

  @Watch('expanded')
  onPropExpanded(val: boolean) {
    this.localExpanded = val;
  }
}
